/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-font[_ngcontent-%COMP%]{font-size:14px;font-weight:325}.desc-font[_ngcontent-%COMP%]{font-size:16px;font-weight:325}.header-font[_ngcontent-%COMP%]{font-size:18px;font-weight:350}\n/*# sourceMappingURL=right-rails.component.css.map*/"];
export { styles as styles };
